import React, { useState } from "react";
import { user } from "../constants";
import { Link } from "react-router-dom";
import Work from "./Modal/Work";
import Login from "./Modal/Login";

const Header = () => {
  const [isWorkModalOpen, setIsWorkModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);


  const handleOpenWorkModal = (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    setIsWorkModalOpen(true);
  };

  const handleCloseWorkModal = () => {
    setIsWorkModalOpen(false);
  };

  const handleOpenLoginModal = () => {
    setIsLoginModalOpen(true);
  };

  const handleCloseLoginModal = () => {
    setIsLoginModalOpen(false);
  };

  return (
    <header className="reqt-header">
      <div className="logo-logo">
      <div className="reqt-logo">
        <Link to={"/"}>
          <img className="imge-header" src="/logo.png" alt="Meea.Fun" />
        </Link>
      </div>

      <nav className="reqt-nav">
      <a href="#how-it-works" onClick={handleOpenWorkModal}>How it Works </a>
        <Link to={"/advance"}>Advanced</Link>
      </nav>
      </div>
      <div className="reqt-notifications">
        <div className="reqt-notification-item">
          <img src="/logo-1.png" alt="User" />
          <span className="head">AAHJAK Sold 0.6478 SOL of Cats</span>{" "}
          <img src="/logo-2.png" alt="User" />
        </div>
        <div className="reqt-notification-item">
          <img src="/logo-1.png" alt="User" />
          <span className="head">
            Gggggg Created Dont Fade on 11&#47;30&#47;24
          </span>{" "}
          <img src="/logo-2.png" alt="User" />
        </div>
      </div>

      {user ? (
        <Link to={"/profile"} className="decoration-none">
          <div className="header-profile">
            <img src="/logo-1.png" alt="User" />
            <p>{user?.name}</p>
          </div>
        </Link>
      ) : (
        <button className="reqt-connect-wallet" onClick={handleOpenLoginModal}>
        <img className="wallet-img" src="wallet.png" alt="User" />
        Connect Wallet
      </button>
      )}
         {/* Render Work Modal */}
         {isWorkModalOpen && <Work onClose={handleCloseWorkModal} />}
         {isLoginModalOpen && <Login onClose={handleCloseLoginModal} />}
    </header>
  );
};

export default Header;
